import styled from 'styled-components'
import { WebpLazyImage } from '../WebpLazyImage/WepbLazyImage'

export const AvatarContainer = styled.div<{ size?: number }>`
  width: ${props => props.size}px;
  height: ${props => props.size}px;
`

export const AvatarImage = styled(WebpLazyImage)<{ clickable: boolean, hasProfileImage: boolean }>`
  aspect-ratio: 1;
  object-fit: cover;
  border-radius: ${props => props.hasProfileImage ? '50%' : '0'};
  width: 100%;
  height: 100%;
  cursor: ${props => props.clickable ? 'pointer' : 'default'};
` 